import { accessToken } from './accessToken';

/**
 * Helper for the redux toolkit's query library to set the authorization header
 * on requests going through the `fetchBaseQuery`:
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Headers
 *
 * @param Headers headers
 * @return Headers
 */
export function prepareHeaders(headers) {
    const token = accessToken.getValue();
    if (token) {
        headers.set('authorization', token.authorizationHeader());
    }

    return headers;
}
